import React from "react";
import { SvgIconProps } from "./SvgIconProps";

const Remove: React.FC<SvgIconProps> = ({ color, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" {...props}>
        <path fill={color || "currentColor"} d="M9.97 0c5.51 0 9.98 4.469 9.98 9.974s-4.47 9.974-9.98 9.974A9.98 9.98 0 0 1 0 9.974 9.98 9.98 0 0 1 9.97 0zm0 8.399L6.58 5.003 5 6.578l3.4 3.396L5 13.37l1.58 1.575 3.39-3.396 3.4 3.396 1.58-1.575-3.4-3.396 3.4-3.396-1.58-1.575-3.4 3.396z"/>
    </svg>
);

export default Remove;